import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
// import i18n from "../../../locale/i18n";

import { mapState } from "vuex";
import alllang from "@/pages/design/locales/alllang";
export default {
  // props: {
  //   showHead:Boolean

  // },

  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      lang: '',
      // langList: uni.getStorageSync('langList'),
      langList: '',
      placeholder: '',
      LanguageShow: false,
      showHead: true
    };
  },
  computed: _objectSpread({}, mapState({
    languages: function languages(state) {
      return state.design.langList;
    },
    languageName: function languageName(state) {
      try {
        var arr = state.design.langList.filter(function (item) {
          return item.langId == state.design.langId;
        });
        return arr[0].langTitle.substring(0, 1);
      } catch (e) {
        return '';
      }
    }
  })),
  mounted: function mounted() {
    // if(this.langList){
    // 	let item = this.langList.filter((item) => {
    // 		return item.langId == uni.getStorageSync('langId')
    // 	})
    //   if(item&&item.length>0) {
    //     this.lang = item[0].langTitle.substring(0, 1)
    //   }
    // }
    //   let langList = window.localStorage.langList
    //   this.langList = JSON.parse(langList)
    //
    // let defaultLangObjStr = window.localStorage.cdefaultLangObj?window.localStorage.cdefaultLangObj:window.localStorage.defaultLangObj;
    // let defaultLangObj = JSON.parse(defaultLangObjStr)
    //
    //   if(this.langList){
    // 		let item = this.langList.filter((item) => {
    // 			return item.langId == defaultLangObj.langId
    // 		})
    //     if(item&&item.length>0) {
    //       this.lang = item[0].langName.substring(0, 1)
    //     }
    // 	}
  },
  methods: {
    handleClick: function handleClick(id, name) {
      var _this = this;
      this.$store.dispatch('design/page_save').then(function (res) {
        if (res.data.code === 200) {
          _this.$store.dispatch('design/form_close');
          var cdefaultLangObj = {};
          cdefaultLangObj.langId = id;
          cdefaultLangObj.langName = name;
          window.localStorage.cdefaultLangObj = JSON.stringify(cdefaultLangObj);
          _this.$store.state.design.langId = id;
          var lang = alllang[id];
          _this.$store.state.design.langCode = lang;
          localStorage.setItem('langCode', lang);
          var arr = _this.$store.state.design.components;
          _this.$store.state.design.components = [];
          _this.$nextTick(function () {
            _this.$store.state.design.components = arr;
          });
        }
      }).catch(function (res) {});
    },
    loadLang: function loadLang(lang) {
      // localStorage.languageCode=getApp().globalData.langList[lang].stlang;//设置本地langcode
      // this._i18n.locale=getApp().globalData.langList[lang].stlang;//设置本地语言code
      // uni.setLocale(getApp().globalData.langList[lang].fulllang);//设置路由中的语言code
      // uni.setStorageSync('langId',lang)
    },
    switchLang: function switchLang(lang) {
      // localStorage.languageCode=getApp().globalData.langList[lang].stlang;
      // this._i18n.locale=getApp().globalData.langList[lang].stlang;
      // uni.setLocale(getApp().globalData.langList[lang].fulllang);
      // this.$api.index.public_info({
      // 	type: 2,
      // }).then((res)=>{
      // 	if(res.code === 200){
      // 		for (let key in res.data) {
      // 			if(key == 'langId'){
      // 				if( uni.getStorageSync('langId') ){
      // 					continue
      // 				}
      // 				uni.setStorageSync(key, res.data[key])
      // 			}
      // 			else {
      // 				uni.setStorageSync('newTime', res.data.noticeInfo.lastUpdateTime)
      // 				uni.setStorageSync(key, res.data[key])
      // 			}
      // 		}
      // 	}
      // }).then(()=>{
      // 	this.$u.route({
      // 		type: 'reLaunch',
      // 		url: "/common/home",
      // 	})
      // })
    },
    //跳转搜索页面
    toSearch: function toSearch() {

      // #ifdef H5
      // let input = document.querySelector('#input')
      // input.focus()
      // // #endif

      // this.$u.route('/search')
    }
  }
};